<template>
  <div class="user-item">
    <div class="user-avatar user-item__avatar">
      <img v-if="avatar !== null && avatar.file_size"
           :src="avatar.url" :alt="`${surname} ${name} ${patronymic}`">
      <img v-else src="/img/svg/avatar__icon.svg" :alt="`${surname} ${name} ${patronymic}`">
    </div>
    <div class="user-item__info">
      <div class="user-item__fio-row">
        {{ surname }}
      </div>
      <div class="user-item__fio-row">
        {{ name }} {{ patronymic }}
      </div>
      <div v-if="user && user.position" class="user-item__position">
        {{ user.position.name | stringMaxLength(30) }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'user-item',
  props: {
    name: String,
    surname: String,
    patronymic: String,
    positionId: Number,
    avatar: Object || null,
    user: Object || null
  },
  data () {
    return {}
  }
}

</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

  .user-item {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    cursor: pointer;

    &__avatar {
      @include size(48px);
      margin-right: 10px;
    }

    &__info {
      color: $color__brown;
      overflow: hidden;
    }

    &__fio-row {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__position {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: .8em;
    }
  }
</style>
